import { IServicePackages } from '../../../../redux/reducers';
import { IServicePackageSchema } from '../../../../repositories/billing-tariffs/v1/publish-terms';
import { mapServiceTypes, getServiceId } from '../../../../utils/publishTerms';
import { getPackageId } from './getPackageId';

export function mapPackages(packages: IServicePackageSchema[]): IServicePackages {
  return packages.reduce((acc, servicePackage) => {
    const { tariffIdentificator } = servicePackage;

    const packageId = getPackageId(servicePackage);
    const services = mapServiceTypes(tariffIdentificator.serviceTypes);
    const serviceId = getServiceId(services);

    acc[packageId] = {
      ...servicePackage,
      id: packageId,
      price: parseFloat(servicePackage.price),
      marketingPrice: parseFloat(servicePackage.marketingPrice),
      serviceId,
      token: servicePackage.token || null,
    };

    return acc;
  }, {} as IServicePackages);
}
